import { createSelector } from 'reselect';
import { professionEventsSelector } from 'selectors';
import { extractDatesFromNestedItems } from 'utils';

export const professionEventsYearsSelector = createSelector([professionEventsSelector], (professionEvents) =>
  extractDatesFromNestedItems(
    [professionEvents.content],
    [
      {
        type: 'range',
        startField: 'startDate',
        endField: 'endDate',
      },
    ],
  ),
);
